import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fromReservation } from 'store/selectors';

import { ShouldRenderDiv } from 'components';

const GuestListEntryExpandedContainer = props => <ShouldRenderDiv {...props} />;

const mapStateToProps = (state, { id }) => {
  const { expanded } = fromReservation.getGuest(state, id);
  return {
    shouldRender: expanded,
  };
};
GuestListEntryExpandedContainer.propTypes = {
  id: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(GuestListEntryExpandedContainer);



// WEBPACK FOOTER //
// ./src/containers/GuestListEntryExpanded.js